import React from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { googleMapsApiKey } from '../../../../../Urls/Services/Api_urls';
import { toLatLng } from './trackingUtils';

const MAP_STYLE = { width: '100%', height: '100%' };

// Muestra solo la dirección de instalación (no la ubicación del técnico en tiempo real)
export const TrackingMap = ({ coordinates, address }) => {
    const position = toLatLng(coordinates);
    if (!position) return null;

    return (
        <section className="bg-white border border-colorfifth rounded-xl p-4 text-left">
            <h6 className="font-semibold text-colorfourth text-left mb-1">Ubicación de la instalación</h6>
            {address && <span className="text-sm text-gray-500 mb-5">{address}</span>}
            <div className="h-64 mt-2 rounded-lg overflow-hidden">
                <LoadScript googleMapsApiKey={googleMapsApiKey}>
                    <GoogleMap mapContainerStyle={MAP_STYLE} center={position} zoom={17}>
                        <Marker position={position} title="Dirección de instalación" />
                    </GoogleMap>
                </LoadScript>
            </div>
            {/* TODO: ubicación del técnico en tiempo real y botón "Ver en mapa" cuando el backend lo exponga */}
        </section>
    );
};
